import type * as React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { COLORS } from "components/v3/Theme/colors";

const expandIcon = (
  <ExpandMoreIcon sx={{ color: COLORS.DARK_GRAY, fontSize: 28 }} />
);

const accordionSx = {
  background: "none",
  borderBottom: `1px solid ${COLORS.PRIMARY_LIGHTEST}`,
  borderRadius: "0 !important",
  boxShadow: "none",
  margin: 0,
  "&::before": {
    display: "none"
  },
  "&.Mui-expanded": {
    margin: 0
  },
  "&:last-of-type": {
    borderBottom: "none"
  }
} as const;

const accordionSummarySx = {
  gap: 2,
  minHeight: 75,
  px: 0,
  py: 2,
  "& .MuiAccordionSummary-content": {
    alignItems: "center",
    margin: 0,
    marginRight: 2,
    pr: 1
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: COLORS.DARK_GRAY,
    marginLeft: 3
  }
} as const;

export const accordionDetailsSx = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  pb: 2,
  pl: 0,
  pr: "35px",
  pt: 0
} as const;

export const bodyParagraphSx = { m: 0 } as const;

export const FaqBody: React.FC<{ children: React.ReactNode }> = ({
  children
}) => (
  <Typography component="div" variant="body_black" sx={bodyParagraphSx}>
    {children}
  </Typography>
);

type MarketingAccordionItemProps = {
  children: React.ReactNode;
  expanded?: boolean;
  onChange?: (event: React.SyntheticEvent, isExpanded: boolean) => void;
  title: string;
};

export const MarketingAccordionItem: React.FC<MarketingAccordionItemProps> = ({
  children,
  expanded,
  onChange,
  title
}) => (
  <Accordion
    disableGutters
    expanded={expanded}
    onChange={onChange}
    sx={accordionSx}
  >
    <AccordionSummary expandIcon={expandIcon} sx={accordionSummarySx}>
      <Typography component="span" variant="body_strong_black">
        {title}
      </Typography>
    </AccordionSummary>
    <AccordionDetails sx={accordionDetailsSx}>{children}</AccordionDetails>
  </Accordion>
);
